import { render } from "./ls.vue?vue&type=template&id=a3d7131c"
import script from "./ls.vue?vue&type=script&lang=js"
export * from "./ls.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__